import React from 'react'
import PropTypes from 'prop-types'
import { scroller } from 'react-scroll'
import MasterData from '../../data/MasterData'
import StationRow from './TrainPositionStationRow'

export default class TrainPositionList extends React.Component {

  static propTypes = {
    lines: PropTypes.array.isRequired,
    trains: PropTypes.array.isRequired,
    lineName: PropTypes.string.isRequired,
    themeName: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
  }

  static contextTypes = {
    intl: PropTypes.object
  }

  componentDidMount() {
    const { station_id } = this.props
    this.scrollToStation(station_id)
    const stationIdMatch = location.href.match(/#station(\d+)$/)
    if (stationIdMatch) this.scrollToStation(stationIdMatch[1])
    const trainIdMatch = location.href.match(/#train(\d+)$/)
    if (trainIdMatch) this.scrollToTrain(trainIdMatch[1])
  }

  scrollToStation(stationId) {
    scroller.scrollTo(`station${stationId}`)
  }

  scrollToTrain(trainId) {
    scroller.scrollTo(`train${trainId}`)
  }

  stations() {
    const { lineName, lines } = this.props
    const lineId = MasterData.lineIdByLineName(lineName)
    return lines.find(l => l.line_id === lineId).stations
  }

  render() {
    const { lineName, lines, trains, themeName, match, history, lineSwitchItem, transferList } = this.props

    return (
      <ul className="d-TrainPosition-station">

        {this.stations().map((station) => {
          return (
            <StationRow
              key={`station${station.id}`}
              lines={lines}
              lineName={lineName}
              trains={trains}
              station={station}
              themeName={themeName}
              match={match}
              history={history}
              lineSwitchItem={lineSwitchItem}
              transferList={transferList}
            />
          )
        })}
      </ul>
    )
  }
}
